

const Spinner = (props) => {
  return (
    <div className="exampleHolder lightningcomponentdemoExampleSpinnerSizes" data-aura-rendered-by="7:116;a" data-aura-class="lightningcomponentdemoExampleSpinnerSizes">
      <lightning-spinner data-aura-rendered-by="8:116;a" className="slds-spinner_container">
          <div role="status" className="slds-spinner slds-spinner_large">
              <span className="slds-assistive-text">Loading</span>
              <div className="slds-spinner__dot-a"></div>
              <div className="slds-spinner__dot-b"></div>
          </div>
      </lightning-spinner>
    </div>
  );
};

export default Spinner;
